import { render, staticRenderFns } from "./TransportMobile.vue?vue&type=template&id=3b325d38&scoped=true&"
import script from "./TransportMobile.vue?vue&type=script&lang=js&"
export * from "./TransportMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b325d38",
  null
  
)

export default component.exports